/* eslint-disable react/require-default-props */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const ImageStyle = (width, height) => ({
  width,
  height,
  objectFit: 'cover',
});

export default class Image extends PureComponent {
  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { src, isSelected, onImageClick } = this.props;
    return (
      <div
        className={`responsive${isSelected ? ' selected' : ''}`}
        onClick={onImageClick}
      >
        <img
          src={src}
          alt=''
          className={`thumbnail${isSelected ? ' selected' : ''}`}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          style={ImageStyle(150, 150)}
        />
        <div className='checked'>
          <div className='icon' />
        </div>
      </div>
    );
  }
}

// TODO: (fix build workaround) Need to be fixed next time when this code will be changed
// @ts-ignore
Image.propTypes = {
  src: PropTypes.string,
  isSelected: PropTypes.bool,
};
